/* 
 * Ranj Mediator Manager
 * @author Javier Quevedo-Fernandez
 * Created on 25 September 2013
 */

import SkinKey from "../ui/SkinKey";
import ScreenNavigatorEvents from "/lib/html5-software-library/src/ranj/ui/ScreenNavigatorEvents";
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class MediatorManager {
    constructor(dispatcher, mediators, mediatorMap) {
        this.dispatcher = dispatcher;
        this.mediators = mediators;
        this.mediatorMapping = mediatorMap;

        this.mediatorMap = {};

        this._registerMediator = this.registerMediator.bind(this);
        this._deregisterMediator = this.deregisterMediator.bind(this);

        this.dispatcher.addEventListener(ScreenNavigatorEvents.ADDED_TO_STAGE, this._registerMediator);
        this.dispatcher.addEventListener(ScreenNavigatorEvents.REMOVED_FROM_STAGE, this._deregisterMediator);
    };

    registerMediator(event) {
        var skin = event.params.data;
        var skinType = event.params.data.skinType;
        var theMediator = this.createMediator(skin, skinType);

        this.mediatorMap[event.params.data.id] = theMediator;
    };

    deregisterMediator(event) {
        var theMediator = this.mediatorMap[event.params.data.id];
        if (theMediator) theMediator.destroy();
        delete this.mediatorMap[event.params.data.id];
    };

    /**
     * Creates a (sub)mediator from a skin and skinKey
     * @param {createjs.Container} skin
     * @param {SkinKey} skinKey
     */
    createMediator(skin, skinKey) {
        // Populate the children property of the movieclip
        this.populateChildren(skin);

        var mediatorClass = this.mediatorMapping.mediatorForSkin(skinKey);
        var theMediator = this.mediators.create(mediatorClass, skin);
        theMediator.initialize();

        return theMediator;
    };

    destroy() {
        if (!isNull(this.dispatcher)) {
            this.dispatcher.removeEventListener(ScreenNavigatorEvents.ADDED_TO_STAGE, this._registerMediator);
            this.dispatcher.removeEventListener(ScreenNavigatorEvents.REMOVED_FROM_STAGE, this._deregisterMediator);
        }
    };

    populateChildren(parent) {
        //Avoid calling gotoAndStop on Sprite instances:
        //  (which would result in showing wrong frame of spriteSheet)
        if (parent.spriteSheet != null) return;

        if (parent.gotoAndStop)
            parent.gotoAndStop(0);

        if (!parent.children)
            return;

        for (var i = 0; i < parent.children.length; i++) {
            this.populateChildren(parent.children[i]);
        }
    };
}